import { useState } from "react";

import { useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import ListItem from "@mui/material/ListItem";

import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";
import SymptomScale from "../ui/symptomScale";
import WidgetList from "../ui/widgetList";

const DemoPatientSymptomsDialog = props => {
  const {
    open,
    dialogTitle = "Symptom Tracker",
    dialogMessage = "Rate your Symptoms below. When you are done, press OK to continue.",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    maxWidth = "sm",
    fullWidth = true,
    symptomData = [],
  } = props;

  const initializeData = theData => {
    let newData = theData.slice();
    for (let i = 0; i < newData.length; ++i) {
      newData[i]["newReportedValue"] = newData[i].averageSeverity;
    }
    return newData;
  };

  const [newSymptomData, setNewSymptomData] = useState(initializeData(symptomData));

  const handleChange = (newValue, valueIndex) => {
    newSymptomData[valueIndex].newReportedValue = newValue;
    setNewSymptomData(newSymptomData);
  };

  const onAcceptHandler = () => {
    props.onAccept(newSymptomData);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        {dialogMessage && (
          <DialogMessage sx={{ marginBottom: theme.spacing(2) }}>{dialogMessage}</DialogMessage>
        )}
        <WidgetList>
          {symptomData.map((symptom, index) => {
            return (
              <ListItem
                key={`symptom${index}`}
                disableGutters={true}
                sx={{
                  padding: 0,
                  margin: 0,
                  marginBottom: theme.spacing(1),
                  backgroundColor: theme.palette.commonground.main,
                  color: theme.palette.commonground.contrastText,
                }}
              >
                <SymptomScale
                  defaultValue={symptom.averageSeverity}
                  defaultLabel={symptom.name}
                  valueEditedHandler={handleChange}
                  valueIndex={index}
                />
              </ListItem>
            );
          })}
        </WidgetList>
      </DialogContent>
      <DialogActions>
        {cancelMessage && (
          <Button onClick={onCloseHandler} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button onClick={onAcceptHandler} color="secondary" variant="contained">
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DemoPatientSymptomsDialog;
